import { PostsTabs } from "./posts-switcher/posts-tabs";

class PostsClass {
  init() {
    PostsTabs.init();
  }
}

export const Posts = new PostsClass();
